import React from "react";
import { useNavigate } from "react-router-dom";

const ConfirmAgreementModal = ({ open, onFinalAgree }) => {
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-white text-start rounded-lg shadow-lg w-[90%] max-w-lg p-6">
        <h2 className="text-xl font-bold mb-4">New Patient Disclaimer</h2>

        <p className="text-gray-700 mb-6">
          You must agree to the terms and conditions to continue with your new
          patient paperwork.  
          If you have questions, contact us at:  
          <strong> 432-582-2446 </strong> or  
          <strong> contactus@high-bp.com</strong>
        </p>

    <div className="flex flex-col sm:flex-row justify-end gap-4 w-full">
  <button
    className="px-5 py-2 rounded bg-gray-300 hover:bg-gray-400 w-full sm:w-auto"
    onClick={() => window.location.href = "https://high-bp.com"}
  >
    I Don't Agree
  </button>

  <button
    className="px-5 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto"
    onClick={onFinalAgree}
  >
    I Agree
  </button>
</div>

      </div>
    </div>
  );
};

export default ConfirmAgreementModal;
